import ModificationType from "../reference/ModificationType";

export class NoAllocationModHandler {
    /**
     * Remaps a NO_ALLOCATION modify order to PROSPECTIVE or RETROSPECTIVE.
     *
     * The new arrangement inherits the modification type and its original modificationDate from the previous arrangement
     *
     */
    static apply(salesOrder: any, previousRevenueArrangement: any): void {
        if (!salesOrder.newRevenueArrangement) {
            throw new Error(
                "NO_ALLOCATION modification requires a new revenueArrangement"
            );
        }

        const previousModType = previousRevenueArrangement?.modificationType;
        salesOrder.originalModificationType = ModificationType.NO_ALLOCATION;

        if (previousModType === ModificationType.PROSPECTIVE) {
            salesOrder.modificationType = ModificationType.PROSPECTIVE;
            salesOrder.newRevenueArrangement.modificationType =
                ModificationType.PROSPECTIVE;

            // set the modification date to the previous modification date
            salesOrder.modificationDate =
                previousRevenueArrangement?.modificationDate;
            salesOrder.newRevenueArrangement.modificationDate =
                salesOrder.modificationDate;
        } else {
            salesOrder.modificationType = ModificationType.RETROSPECTIVE;
            salesOrder.newRevenueArrangement.modificationType =
                ModificationType.RETROSPECTIVE;
        }
    }
}
